export const GLOWNY_SPECJALISTA_DS_BEZPIECZENSTWA_SYSTEMOW_TELEINFORMATYCZNYCH_EXATEL = 'cfec8e0a-816c-4353-8a96-c49cce2e628d';